import lodash from "lodash-es";
import type { RouteRecordRaw } from "vue-router";
/**
 * 将平级遍历为树形
 * @param {(Array)} data
 * @returns {Array}
 */
export type TreeNodeType = {
  children?: TreeNodeType[];
  sequence?: number;
  label?: string;
  parentLabel?: string;
  frontPath?: string;
  name: string;
  parentId: string | number;
  code: string;
  id: string | number;
  level?: number;
};

export type TreeBaseNodeType = {
  children?: TreeBaseNodeType[];
  sequence?: number;
  label?: string;
  parentLabel?: string;

  name: string;
  parentId: string | number;

  id: string | number;
};
export function toTree(data: TreeBaseNodeType[]): TreeBaseNodeType[] {
  const result: TreeBaseNodeType[] = [];
  if (!Array.isArray(data)) {
    return result;
  }
  data.forEach((item) => {
    delete item.children;
  });
  const map: Record<string | number, TreeBaseNodeType> = {};
  data.forEach((item: TreeBaseNodeType) => {
    item.label = item.name;
    map[item.id] = item;
  });
  data.forEach((item) => {
    const parent = map[item.parentId];
    if (parent) {
      item.parentLabel = parent.label;
      (parent.children || (parent.children = [])).push(item);
    } else {
      result.push(item);
    }
  });
  return result;
}

// 通过角色菜单过滤出对应的树形菜单，判断条件如果子级符合条件父级也应该符合条件
export function filterRoleMenu(
  treeMenu: TreeNodeType[],
  roleMenuMap: Record<string | number, TreeNodeType>,
  pagesCodeMap: Record<string | number, TreeNodeType> = {}
): TreeNodeType[] {
  const res: TreeNodeType[] = [];

  treeMenu.map((o: TreeNodeType) => {
    if (o.children && o.children.length) {
      const childNodes: TreeNodeType[] = filterRoleMenu(
        o.children,
        roleMenuMap,
        pagesCodeMap
      );
      if (childNodes.length) {
        const setItem = lodash.cloneDeep(o);
        setItem.children = childNodes;
        res.push(setItem);
      }
    } else if (roleMenuMap[o.id]) {
      pagesCodeMap[o.code] = o;

      const setItem = lodash.cloneDeep(o);
      if (!setItem.frontPath && roleMenuMap[o.id].frontPath) {
        setItem.frontPath = roleMenuMap[o.id].frontPath;
      }
      res.push(setItem);
    }
  });
  return res;
}

export function sortTree(tree: TreeBaseNodeType[]): TreeBaseNodeType[] {
  tree = lodash.sortBy(tree, function (item) {
    return item.sequence;
  });
  tree = tree.map((o) => {
    if (o.children) {
      o.children = sortTree(o.children);
    }
    return o;
  });
  return tree;
}
export function initFixedRoutesAndTreeMenuData(
  baseRoutes: RouteRecordRaw
): TreeNodeType[] {
  const res: TreeNodeType[] = [];

  return res;
}
